import { render, staticRenderFns } from "./HappeningNow.vue?vue&type=template&id=7fab8198"
import script from "./HappeningNow.vue?vue&type=script&lang=js"
export * from "./HappeningNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports